import React from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import ManageAddress from './ManageAddress';

const MyAddress = () => {
    return (
        <Box sx={{ display: 'flex' }}>
            <Sidebar />
            <Box sx={{ marginTop:3, width:'100%' }}>
                <ManageAddress />
            </Box>
        </Box>
    );
};

export default MyAddress;